import store from '@/store';
import { getModule } from 'vuex-module-decorators';
import { NotificationsStoreModule } from './module';

export const NotificationsModule = getModule(NotificationsStoreModule, store);
